import React, { memo, useState, useEffect, useRef } from "react"
import * as styles from "../../page_css/page.css"
import Layout from "../../components/layout"
import { PageProps } from "../../types"
import PageHero from "../../components/page-hero"
import * as blocks from "../../components/blocks"
import Fallback from "../../components/fallback"
import Flash from "../../components/flash"
import { useLocation } from '@reach/router';

import {
  breakpoints
} from "../../components/ui.css"

const getWindowWidth = () => window.innerWidth 
  || document.documentElement.clientWidth 
  || document.body.clientWidth

const desktopBool = () => {
  if (typeof window !== "undefined") {
    return getWindowWidth() > breakpoints[2] ? true : false
  }
}

export default function Columns(props: PageProps) {
  const { page } = props.data
  const [isDesktop, setIsDesktop] = useState(desktopBool())
  const [hasWindow, setHasWindow] = useState(false)

  const background = page.pageBackground ? {
    image: page.pageBackground,
    overlayColor: page.backgroundOverlayColor || null,
    overlayOpacity: page.backgroundOverlayOpacity || null,
  } : null
  const heroImage = page.heroImage? {
    image: page.heroImage,
    overlayColor: page.heroOverlayColor || null,
    overlayOpacity: page.heroOverlayOpacity || null,
  } : null

  let sectionCount = 0
  const sections = [{ content: []}]
  page.content?.map((block, i) => {
    const { id, blocktype, desktopRight, displayFullWidth, ...componentProps } = block
    const Component = memo(blocks[blocktype] || Fallback)
    const column = block.blocktype === "Break"
                ? "break"
                : displayFullWidth
                  ? "full"
                  : desktopRight
                    ? "right"
                    : "left";
    
    if(column == "break" || column == "full" ) {
      sectionCount++
      sections.push({ content: []})
    }
    sections[sectionCount].content.push({
        column: column,
        component: <Component key={id} id={id} blocktype={blocktype} displayFullWidth={displayFullWidth} {...(componentProps as any)} />,
    })
    if(column == "break" || column == "full") {
      sectionCount++
      sections.push({ content: []})
    }
  })
  
  useEffect(() => {
    const handleIsDesktop = () => {
      setIsDesktop(desktopBool())
    }
    
    if (typeof window !== "undefined") {
      setHasWindow(true)
      window.addEventListener('resize', handleIsDesktop);
      return () => {
        window.removeEventListener('resize', handleIsDesktop);
      }
    }
  }, [])

  const location = useLocation(); // Get current location
  const currentPath = location.pathname; // Current path
  const homepageClass = currentPath === "/" ? "homepage" : ""
  return (
    <Layout background={background} location={currentPath}>
      <PageHero location={currentPath} title={page.title} subtitle={page?.subtitle} {...heroImage} {...page} hidePageTitle={page?.hidePageTitle} />
      <div className={`${styles.pageContainer} entitylistpage ${homepageClass}`}>
        {hasWindow && (
          <div>
            {sections.map((section, i) => {
              const leftContent = section.content.filter(block => block.column == "left")
              const rightContent = section.content.filter(block => block.column == "right")
                
                if(section.content[0]?.column == "full") {
                  return (
                    <div key={i} className={`${styles.columnsContainer} fullpage`}>
                      {section.content.map((block) => block.component )}
                    </div>
                  )
                }
                 else if(section.content[0]?.column == "break") {
                  return <div key={i}>{section.content[0].component}</div>
                } 
                
                else {
                  return (
                    <React.Fragment key={`section-${i}-maincontent-${i}-${i}`}>
                      {(leftContent.length > 0 || rightContent.length > 0) && (
                        <div key={`b${i}`} className={styles.columnsContainer}>
                          <section key={`c${i}`}className={styles.pageColumn}>
                            {!isDesktop ? 
                              // Preserve the order by rendering all content in the original order, not combined:
                              section.content.map((block, index) => { 
                                return (<React.Fragment key={`section-${i}-content-${index}`}>{block.component}</React.Fragment>)
                              }
                            ) : 
                              leftContent?.map((block, index) => 
                                {
                                  return (
                                    <React.Fragment key={`section-${i}-left-${index}`}>{block.component} </React.Fragment>
                                  )
                                })
                            }
                          </section>
                          
                          {isDesktop && rightContent.length > 0 && (
                            <section  key={`section-${i}-right`} className={styles.pageColumn}>
                              {rightContent?.map((block, index) => 
                              {
                                return (
                                  <React.Fragment key={`section-${i}-right-${index}`}>{block.component} </React.Fragment>
                                ) 
                              }
                              )}
                            </section>
                          )}
                        </div>
                      )}
                    </React.Fragment>
                  )
                } 
            })}
          </div>
        )}
      </div>
    </Layout>
  )
}